import { render, staticRenderFns } from "./EditInformasiUmum.vue?vue&type=template&id=544750a2&scoped=true&"
import script from "./EditInformasiUmum.vue?vue&type=script&lang=js&"
export * from "./EditInformasiUmum.vue?vue&type=script&lang=js&"
import style0 from "./EditInformasiUmum.vue?vue&type=style&index=0&id=544750a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544750a2",
  null
  
)

export default component.exports